import { AppError } from "../../domain/models/appError";
const firebaseToAppError = {
    "auth/invalid-credential": "invalidCredentials",
    "auth/user-not-found": "userNotFound",
    "auth/wrong-password": "invalidCredentials",
    "auth/email-already-in-use": "emailAlreadyInUse",
    "auth/weak-password": "weakPassword",
    "auth/invalid-email": "invalidEmail",
    "auth/user-disabled": "userDisabled",
    "auth/not-authenticated": "notAuthenticated",
    "auth/operation-not-allowed": "operationNotAllowed",
    "auth/network-request-failed": "network",
    "auth/too-many-requests": "tooManyRequests",
    "auth/requires-recent-login": "notAuthenticated",
    "auth/invalid-verification-code": "invalidCredentials",
    "auth/invalid-phone-number": "invalidEmail",
    "auth/missing-phone-number": "invalidEmail",
    "auth/quota-exceeded": "tooManyRequests",
    "auth/app-not-authorized": "permissionDenied",
    "auth/credential-already-in-use": "emailAlreadyInUse",
    "auth/provider-already-linked": "operationNotAllowed",
    "auth/no-such-provider": "notFound",
    "firestore/permission-denied": "permissionDenied",
    "firestore/not-found": "notFound",
    "firestore/unavailable": "network",
    "firestore/cancelled": "network",
    "firestore/deadline-exceeded": "network",
    "firestore/aborted": "network",
    "firestore/resource-exhausted": "tooManyRequests",
    "functions/permission-denied": "permissionDenied",
    "functions/not-found": "notFound",
    "functions/resource-exhausted": "tooManyRequests",
    "functions/unavailable": "network",
    "functions/internal": "unknown",
    "functions/invalid-argument": "unknown",
    "storage/unauthorized": "permissionDenied",
    "storage/object-not-found": "notFound",
    "storage/canceled": "network",
    "storage/retry-limit-exceeded": "network",
};
export function mapFirebaseError(error) {
    if (error instanceof AppError)
        return error;
    const fbError = error;
    const code = fbError?.code ?? "unknown";
    const mappedCode = firebaseToAppError[code] ?? "unknown";
    return new AppError(mappedCode, fbError?.message);
}
//# sourceMappingURL=errorMapper.js.map